// in src/utils/socketService.js

import { io } from 'socket.io-client';

const URL = process.env.NODE_ENV === 'development'
            ? 'http://localhost:5001'
            : process.env.REACT_APP_API_URL_BASE;

let socketInstance = null; // Istanza Singleton

export const getSocket = () => {
    // Se l'istanza non è mai stata creata, creala e configurala
    if (!socketInstance) {
        
        
        socketInstance = io(URL, {
            autoConnect: false, // Prendiamo noi il controllo della connessione
            reconnection: true,
            reconnectionDelay: 1000,
            reconnectionAttempts: 10
        });

        // Listener di debug per monitorare lo stato del socket
        socketInstance.on('connect', () => {
            console.log(`[SocketService] Connesso con successo con ID: ${socketInstance.id}`);
        });

        socketInstance.on('disconnect', (reason) => {
            console.warn(`[SocketService] Disconnesso. Ragione: ${reason}`);
        });

        socketInstance.on('connect_error', (err) => {
            console.error(`[SocketService] Errore di connessione: ${err.message}`);
        });
    }

    // Se l'istanza esiste ma non è connessa, prova a connetterti
    if (!socketInstance.connected) {
        socketInstance.connect();
    }
    
    // Restituisci sempre la stessa istanza
    return socketInstance;
};

export const disconnectSocket = () => {
    if (socketInstance) {
        console.log('[SocketService] Disconnessione manuale del socket.');
        socketInstance.disconnect();
        socketInstance = null; // Forza la ricreazione alla prossima chiamata di getSocket (es. dopo nuovo login)
    }
};